<template>
	<div class="home">
		<HeaderBar :title="title"></HeaderBar>
		<div class="center-box-no-footer">

			<div class="patient-card-box" v-show="false">
				<div class="patient-card-content">
					<div class="content-title">
						<span class="custom-title">{{form.bq001002}}</span>
						<span class="custom-title">{{form.bq001018}}</span>
					</div>
					<div class="content-info">
						<div class="patient-status">治疗组</div>
						<div class="patient-info-item">{{form.sex}}</div>
						<div class="patient-info-item">{{form.age}}岁</div>
					</div>
					<div class="content-info">
						<div class="patient-info-item">{{config.usertype.find(item=>item.id==form.bq001041).text}}</div>
						<div class="patient-info-item">{{form.employerName}}</div>
					</div>
					<embed class="patient-icon" :src="patientIcon" type="image/svg+xml"
						pluginspage="http://www.adobe.com/svg/viewer/install/" />
				</div>
			</div>


			<div class="patient-record-box">
				<div class="record-title">随访记录</div>
				<div class="record-item" v-for="item in recordList" :key="item.guid" @click="Record(item)">
					<van-cell center is-link>
						<template #title>
							<div class="record-time">{{item.bq400995}}</div>
						</template>
						<template #label>
							<div class="record-info-item">
								<div class="record-info-text custom-title">{{item.bs025003}}</div>
								<div class="record-info-type">随访名称</div>
							</div>
							<div class="record-info-item">
								<div class="record-info-text custom-title" v-if="item.bq400996=='0'"
									style="color:#409EFF;">未提交</div>
								<div class="record-info-text custom-title" v-if="item.bq400996=='1'"
									style="color:#909399;">转换中</div>
								<div class="record-info-text custom-title" v-if="item.bq400996=='2'"
									style="color:#f56c6c;">数据异常</div>
								<div class="record-info-text custom-title" v-if="item.bq400996=='3'"
									style="color:#67c23a;">随访完成</div>
								<!-- <div class="record-info-text custom-title">9个月</div> -->
								<div class="record-info-type">随访状态</div>
							</div>
							<!--              <div class="record-info-item">
                <div class="record-info-text custom-title">-</div>
                <div class="record-info-type">抗病毒周期</div>
              </div> -->
						</template>
					</van-cell>
				</div>
			</div>
		</div>



		<van-popup v-model="showPopup" closeable position="right" :style="{ width: '100%','height':'100%' }">
			<div class="setting-right-content">
				<followRecordIndex v-if="showPopup" userMode="patient"></followRecordIndex>
			</div>
		</van-popup>

	</div>
</template>

<script>
	import componentsModel from '../base/components.js'
	import followRecordIndex from '../followRecord/index.vue'
	export default {
		name: 's400PatientDetail',
		data() {
			return {
				title: '随访信息',
				searchValue: "",
				// 背景图片
				patientIcon: require("../../../../assets/image/patient-icon.svg"),
				config: JSON.parse(sessionStorage.getItem("config")),
				form: {
					id: '0', //编号
					guid: '', //guid编号
					companyGuid: '', //单位编号
					departmentGuid: '', //部门编号
					checkStatus: '', //审核状态
					dataStatus: '', //数据状态
					addUid: '', //添加人编号
					addTime: '', //添加时间
					extend1: '', //扩展字段
					extend2: '', //扩展字段
					extend3: '', //扩展字段
					extend4: '', //扩展字段
					extend5: '', //扩展字段
					bq001002: '', //患者姓名
					bq001018: '', //身份证号
					bq001003: '1', //性别,1-男，2-女
					bq001004: '', //出生年月
					bq001012: '', //民族编号
					bq001007: '', //电话号码
					bq001006: '', //备用电话
					bq001032: '健在', //是否健在 健在，死亡
					bq0010322: '', //死亡时间
					bq0010323: '', //死亡原因
					bq001040: '', //入组日期
					bq001041: 1, //随访方案
					bq001042: '0', //随访状态
					bq001043: '', //主治医生编号
					bq001044: '', //主治医生姓名
					Bq001_002: '', //患者姓名
					Bq001_018: '', //身份证号
					Bq001_003: '', //性别,1-男，2-女
					Bq001_004: '', //出生年月
					Bq001_012: '', //民族编号
					Bq001_007: '', //电话号码
					Bq001_006: '', //备用电话
					Bq001_032: '健在', //是否健在 健在，死亡
					Bq001_032_2: '', //死亡时间
					Bq001_032_3: '', //死亡原因
					Bq001_040: '', //入组日期
					Bq001_041: 1, //入组方案
					Bq001_042: 0, //入组标识0-未入组，1-入组
					Bq001_043: '', //主治医生编号
					Bq001_044: '', //主治医生姓名不用
				},
				recordList: [],
				loading: false,
				// 随访记录pop
				showPopup: false,

			}

		},
		// 页面渲染，初始化form的数据
		created() {
			// this.form = this.$route.params
			// console.log(this.form);
		},
		components: {
			followRecordIndex,
			...componentsModel
		},
		methods: {
			onSearch() {

			},
			// 记录页面
			Record(item) {
				sessionStorage.setItem('bq400', JSON.stringify(item))
				this.showPopup = true
			},

			// 获得病例的详细信息
			LoadPatientInfo() {
				console.log(this.$route.params);
				let that = this
				var args = {
					bq001018: that.$route.params.patientCard
				}
				that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq001/Info', args,
					function(d) {
						let dataModel = d.data
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.form = dataModel.bq001
						// that.$utils.CopyPro(dataModel.bq001, that.form)
						console.log(that.form);
					})
				// this.loadinfo()
			},
			//获取随访列表
			loadinfo: function() {
				let that = this
				let patientCard = that.$route.params.patientCard
				var condition = {
					bq001018: patientCard,
					patuid: that.$route.params.id,
					currentPage: 1,
					pageSize: 9999,
					recordCount: 0,
				}
				that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400/ListByUid', condition, function(d) {
					let dataList = []
					d.data.forEach((item)=>{
						that.$utils.CopyKeyInfo(item, item)
						dataList.push(item)
					})
					// 已选中的随访类型数组
					let typeSelectedList = dataList.map(item => item.bs025003)
					// 获得当前操作所有的类型数组
					let allSetList = that.config.usertype.find(item => item.id == that.form.bq001041).date
					// 获得还未进行的标准随访数据
					that.recordSetList = allSetList.filter(m => typeSelectedList.indexOf(m + "随访") == -1)
					that.recordList = dataList
					that.loading = false
					// that.autoLoadFollow()
				}, null, null, null)
			},
			autoLoadFollow: function() {
				//找到最后一次标准随访，调用方法，显示时间轴
				var followlist = this.recordList.filter(item => {
					return item.bq400999 < 2
				})
				if (followlist) {
					this.clickFollowItem(followlist[followlist.length - 1])
				}
			}
		},
		mounted() {
			console.log(this.$route.params)
			this.loadinfo()
		}
	}
</script>
<style scoped>
	.center-box-no-footer {
		padding-bottom: 80px;
	}

	.patient-card-box {
		padding: 15px 1rem;
		width: 100%;
		box-sizing: border-box;
	}

	.patient-card-content {
		width: 100%;
		height: 120px;
		background-color: #fff;
		border-radius: 8px;
		padding: 20px;
		box-sizing: border-box;
		position: relative;
	}

	.patient-card-content .content-title span {
		padding-right: 10px;
	}

	.content-info {
		padding-top: 5px;
	}

	.content-info .patient-status {
		margin-right: 10px;
	}

	.patient-status {
		display: inline-block;
		height: 20px;
		width: 60px;
		line-height: 20px;
		text-align: center;
		font-size: 10px !important;
		color: #FF7B61;
		background: rgba(255, 123, 97, 0.06);
		border: 1px solid #FF7B61;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.patient-detail .patient-status.active {
		background: rgba(64, 158, 255, 0.06);
		border: 1px solid #409EFF;
		color: #409EFF;
	}

	.patient-info-item {
		display: inline-block;
		height: 20px;
		line-height: 20px;
		padding: 0 10px;
		background: #F7F7F7;
		border-radius: 4px;
		font-size: 10px;
		color: #666666;
		text-align: center;
		margin-right: 10px;
	}

	.patient-icon {
		position: absolute;
		right: 0;
		bottom: 0;
		width: 83px;
		height: 87px;
	}

	.patient-record-box {
		padding-top: 5px;
		padding: 5px 1rem 0 1rem;
	}

	.patient-record-box .record-title {
		font-size: 14px;
		color: #666666;
		line-height: 14px;
		font-weight: 400;
		padding-bottom: 10px;
	}

	.record-item {
		padding-bottom: 10px;

	}

	.record-item .van-cell--center {
		border-radius: 9px;
		padding: 20px;
	}

	.record-item .record-time {
		font-size: 14px;
		color: #666666;
		line-height: 14px;
		font-weight: 400;
	}

	.record-item .van-cell__label {
		display: flex;
	}

	.record-info-item {
		flex: 1;
		display: inline-block;
		padding-top: 15px;
	}

	.record-info-type {
		font-size: 14px;
		color: #999999;
		line-height: 14px;
		font-weight: 400;
		padding-top: 10px;
	}

	.patient-bottom-box {
		width: 100%;
		height: 80px;
		padding: 0 1rem;
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
	}

	.patient-bottom-box .patient-button-box {
		background-color: #fff;
		width: 100%;
		height: 100%;
		padding-bottom: 10px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	.patient-bottom-box .patient-button-box .van-button {
		width: 48%;
	}
</style>
